export default "__VITE_ASSET__8b0aa78e__"